<template>
  <div class="third">
    <div class="third-formOne import-backlog">
      <div class="formOne-btn">
        <div class="btn-left">
          <span class="left-back-icon"
                @click="goBack">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>
          <span class="left-back-content">服务配置》{{currentName}}</span>
        </div>
        <div class="btn-right">
          <el-button @click="resetForm"
                     class="btn-two"
                     type="default">重置</el-button>
          <el-button @click="commit"
                     class="btn-two"
                     type="primary"
                     v-el-disabel-repeat-click>保存</el-button>
        </div>
      </div>
      <el-form @validate="validateValue"
               :show-message="false"
               :model="ruleForm"
               :rules="rules"
               ref="ruleForm"
               label-width="120px">
        <div class="formOne-forms">
          <div class="forms-one"
               style="margin-top: 57px;">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">基本信息</span>
              </div>
            </div>
            <div class="one-list">
              <div class="list-across-line">
                <el-form-item label="卡片展示名称1"
                              v-if="ruleForm.serviceInfoVOS"
                              :prop="'serviceInfoVOS.' + 0 + '.columnName'"
                              :rules="{
                                required: true, message: '请输入卡片展示名称1', trigger: 'blur'
                              }">
                  <el-input class="list-input"
                            :maxlength="4"
                            v-model.trim="ruleForm.serviceInfoVOS[0].columnName"
                            placeholder="请输入“我发起的”卡片展示名称"></el-input>
                  <div class="hint">学生、教工、其他用户可见</div>
                </el-form-item>
                <el-form-item label="卡片访问链接"
                              :prop="'serviceInfoVOS.' + 0 + '.columnUrl'"
                              :rules="{
                                required: true, validator: http, trigger: 'blur'
                              }"
                              v-if="ruleForm.serviceInfoVOS">
                  <el-input class="list-input"
                            v-model.trim="ruleForm.serviceInfoVOS[0].columnUrl"
                            maxlength="1000"
                            placeholder="请输入$符号开头的相对路径或完整的http(s)路径"></el-input>
                  <span></span>
                </el-form-item>
              </div>
              <div class="list-across-line">
                <el-form-item label="卡片展示名称2"
                              :prop="'serviceInfoVOS.' + 1 + '.columnName'"
                              :rules="{
                                required: true, message: '请输入卡片展示名称2', trigger: 'blur'
                              }"
                              v-if="ruleForm.serviceInfoVOS">
                  <el-input class="list-input"
                            :maxlength="4"
                            v-model.trim="ruleForm.serviceInfoVOS[1].columnName"
                            placeholder="请输入“我的待办”卡片展示名称"></el-input>
                  <div class="hint">教工可见</div>
                </el-form-item>
                <el-form-item label="卡片访问链接"
                              :prop="'serviceInfoVOS.' + 1 + '.columnUrl'"
                              :rules="{
                                required: true, validator: http, trigger: 'blur'
                              }"
                              v-if="ruleForm.serviceInfoVOS">
                  <el-input class="list-input"
                            maxlength="1000"
                            v-model.trim="ruleForm.serviceInfoVOS[1].columnUrl"
                            placeholder="请输入$符号开头的相对路径或完整的http(s)路径"></el-input>
                </el-form-item>
              </div>
              <div class="list-across-line">
                <el-form-item label="卡片展示名称3"
                              :prop="'serviceInfoVOS.' + 2 + '.columnName'"
                              :rules="{
                                required: true, message: '请输入卡片展示名称2', trigger: 'blur'
                              }"
                              v-if="ruleForm.serviceInfoVOS">
                  <el-input class="list-input"
                            :maxlength="4"
                            v-model.trim="ruleForm.serviceInfoVOS[2].columnName"
                            placeholder="请输入“抄送我的”卡片展示名称"></el-input>
                  <div class="hint">教工可见</div>
                </el-form-item>
                <el-form-item label="卡片访问链接"
                              :prop="'serviceInfoVOS.' + 2 + '.columnUrl'"
                              :rules="{
                                required: true, validator: http, trigger: 'blur'
                              }"
                              v-if="ruleForm.serviceInfoVOS">
                  <el-input class="list-input"
                            maxlength="1000"
                            v-model.trim="ruleForm.serviceInfoVOS[2].columnUrl"
                            placeholder="请输入$符号开头的相对路径或完整的http(s)路径"></el-input>
                </el-form-item>
              </div>
              <div class="list-across-line"
                   style="marginBottom:20px">
                <el-form-item label="卡片顺序"
                              prop="orderNum">
                  <el-input class="list-input"
                            :maxlength="2"
                            v-model.trim="ruleForm.orderNum"
                            placeholder="请输入正整数"></el-input>
                </el-form-item>
              </div>
              <div class="list-across-line">
                <el-form-item label="发起待办链接"
                              :prop="'serviceInfoVOS.' + 3 + '.columnUrl'"
                              :rules="{
                                required: true, validator: http2, trigger: 'blur'
                              }"
                              v-if="ruleForm.serviceInfoVOS">
                  <el-input class="list-input"
                            maxlength="1000"
                            v-model.trim="ruleForm.serviceInfoVOS[3].columnUrl"
                            placeholder="请输入$符号开头的相对路径或完整的http(s)路径"></el-input>
                </el-form-item>
              </div>

            </div>
          </div>
        </div>
      </el-form>
    </div>
    <preview-modal :previewModal="dialogVisible"
                   :previewImageUrl="dialogImageUrl"
                   @previewClose="closePreview"></preview-modal>
  </div>
</template>

<script>
import { upicon, add } from "@/api/slidenshow/slidenshow";
import { itemDetailPort, updatePort } from '@/api/appSetting/appServiceSetting'

export default {
  name: "timetable",
  props: ['rowId'],
  data () {
    const blurText = async (rule, value, callback) => {
      const boolean = new RegExp("^[1-9][0-9]*$").test(value); // console.log(boolean)
      if (!boolean) {
        callback(new Error("请输入正整数"));
      }
    };
    var http = (rule, value, callback) => {
      if (this.ruleForm.articleType == 3 && !value) {
        callback(new Error("请输入专题详情链接"));
      } else if (this.ruleForm.articleType == 3 && value) {
        var reg = /(^http[s]?:\/\/.*)|(^\${HOST}*)/;
        if (!reg.test(value)) {
          callback(new Error("请输入正确格式的链接（http[s] 或 ${HOST}）"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      cpRowId: this.rowId,
      currentName: '',
      countNum: 1, //用于显示第一个错误
      dialogImageUrl: "",
      dialogVisible: false,
      pointList: [],
      rules: {
        orderNum: [
          { required: true, message: "请输入卡片顺序", trigger: "blur" },
          { validator: blurText, trigger: "blur" } //表单验证的时候会调用的方法
        ],
        showName: [{ required: true, message: "请输入课程表卡片展示名称", trigger: "blur" }],
        serviceLink: [{ required: true, validator: http, trigger: "blur" }]
      },
      ruleForm: {
        id: "",
        showName: '',
        orderNum: '',
        serviceLink: '',
      },
      uploadFilter: ['.jpg', '.jpeg', '.png'],
      canAdd: true, // 是否可以新增
    };
  },
  created () {
    this.itemDetail()
  },
  watch: {
    rowId () {
      this.cpRowId = this.rowId
    }
  },
  methods: {
    http (rule, value, callback) {
      if (!value) {
        callback(new Error("请输入卡片访问链接"));
      } else if (value) {
        var reg = /(^http[s]?:\/\/.*)|(^\${HOST}*)/;
        if (!reg.test(value)) {
          callback(new Error("请输入正确格式的卡片访问链接（http[s] 或 ${HOST}）"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    http2 (rule, value, callback) {
      if (!value) {
        callback(new Error("请输入发起待办链接"));
      } else if (value) {
        var reg = /(^http[s]?:\/\/.*)|(^\${HOST}*)/;
        if (!reg.test(value)) {
          callback(new Error("请输入正确格式的发起待办链接（http[s] 或 ${HOST}）"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    async itemDetail () {
      console.log('this.cpRowId', this.cpRowId)
      const {
        data: {
          result, msg, status
        }
      } = await itemDetailPort({
        id: this.rowId
      })
      if (status === 1000) {
        console.log(result);
        this.currentName = result.itemName
        this.ruleForm = result
        console.log('结果', result)
        return
      }
      return this.$message.error(msg)
    },
    async updateData () {
      let arr = []
      this.ruleForm.serviceInfoVOS.forEach((item, i) => {
        if (i <= 2) {
          arr.push(item.columnName)
        }
      })
      console.log('this.cpRowId', this.cpRowId)
      const {
        data: {
          result, msg, status
        }
      } = await this.$store.dispatch('serviceItemUpdate', {
        ...this.ruleForm,
        showName: arr.join('、')
      })
      if (status === 1000) {
        this.$message.success('保存成功')
        this.goBack()
        console.log('结果', result)
        return
      }
      return this.$message.error(msg)
    },
    goBack () {
      this.$emit("changeComponent", 'homePage');
    },
    //上传图片
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //移除
    handleRemove (file, fileList) {
      console.log(file, fileList);
      this.ruleForm.imgUrl = "";
    },
    // 超出
    handleExceed (files, fileList) {
      console.log(files, fileList);
    },
    // 成功
    handleSuccess () {
      console.log(this.fileList);
      console.log(111);
    },
    // 上传失败
    hadleError (err) {
      this.$message.error(err);
    },
    //获取学校详情
    selectinfo () {
      // debugger
      console.log(this.ruleForm)
      this.fileList = [];
      this.ruleForm = this.ID;
    },
    // 提交表单
    commit () {
      this.countNum = 0;
      this.$nextTick(() => {
        this.$refs.ruleForm.validate(valid => {
          console.log("valid", valid);
          if (valid) {
            this.countNum = 1;
            this.updateData()
          } else {
            return false;
          }
        });
      });
    },
    // 验证
    validateValue (prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    //表单验证
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //表单重置
    resetForm () {
      this.$refs.ruleForm.clearValidate()
      this.$nextTick(() => {
        this.itemDetail()
      })
    },
    //关闭预览弹窗
    closePreview () {
      this.dialogVisible = false;
    },
    //行政区域选中节点
    handleChange (value) {
      console.log(value);
    }
  }
};
</script>

<style lang="scss">
.import-backlog {
  height: 100vh !important;
  .fileDisabled {
    .el-upload--picture-card {
      display: none;
    }
  }
  .list-across-line {
    display: flex;
    .hint {
      font-size: 12px;
      color: #cccccc;
    }
  }
}
</style>
